import React from 'react';
import { LoaderOrangeRings } from '../../loaders/loaderOrangeRings/LoaderOrangeRings';
import { useFooterPaymentMethods } from '../store';
import FooterPaymentMethodLogo from './FooterPaymentMethodLogo';
import { useDarkTheme } from '../../../common/theme';

export const FooterPaymentMethodsList = ({ imgHeight, className }) => {
    const { data, status } = useFooterPaymentMethods();
    const isDarkTheme = useDarkTheme();

    if (status === 'loading') {
        return <LoaderOrangeRings />;
    }

    if (!data) {
        return null;
    }

    return (
        <>
            {data.map(paymentMethod => (
                <FooterPaymentMethodLogo
                    key={paymentMethod.alt}
                    method={paymentMethod}
                    imgHeight={imgHeight}
                    className={className}
                    darkTheme={isDarkTheme}
                />
            ))}
        </>
    );
};
